/* eslint-disable no-trailing-spaces */
/* eslint no-console: ["error", { allow: ["warn", "error", "info"] }] */
/* eslint no-invalid-this: 0 */
/* eslint max-len: 0 */

export function pushCheckoutError(errorMsg, step = null) {
	window.dataLayer = window.dataLayer || [];

	if (errorMsg) {
		let dataLayerObj = {
			'event': 'checkout error',
			'text': errorMsg,
		};

		// content grouping
		if (step == 3) {
			dataLayerObj.pageType = 'login';
		}

		if (step == 4) {
			dataLayerObj.pageType = 'delivery';
		}

		window.dataLayer.push(dataLayerObj);
	}
}

export async function puchCheckoutSteps(step, option, pushProducts = false, url = false, form = false) {
	// Measure adding a product to a shopping cart by using an 'add' actionFieldObject
	// and a list of productFieldObjects.
	window.dataLayer = window.dataLayer || [];
	if (form) {
		form.removeAttr('submited');
	}

	let datasource = [];

	// defined globally by BE;
	// eslint-disable-next-line no-undef
	if (typeof datalayerDataSource != 'undefined') {
		// defined globally by BE;
		// eslint-disable-next-line no-undef
		datasource = datalayerDataSource || [];
	}

	if (datasource.length > 0) {
		let first = datasource[0];
		let dataLayerObj = {
			'event': 'checkout',
			'ecommerce': {
				'currencyCode': first.currency,
				'checkout': {
					'actionField': {
						'step': step,
						'option': option,
					},
				},
			},
			'eventCallback': function() {
				if (url) {
					window.location = window.location.pathname;
					return Promise.resolve();
				}
				if (form) {
					if(!form.attr('submited')) {
						form.submit();
						form.attr('submited', true);
					}

					return Promise.resolve();
				}
				return Promise.resolve();
			},
		};
		if (pushProducts) {
			dataLayerObj.ecommerce.checkout.products = datasource;
		}

		// content grouping
		if (step == 3) {
			dataLayerObj.pageType = 'login';
		}

		if (step == 4) {
			dataLayerObj.pageType = 'delivery';
		}

		window.dataLayer.push(dataLayerObj);
	}
}

export async function pushEmailsWithPromise() {
	// Measure adding a product to a shopping cart by using an 'add' actionFieldObject
	// and a list of productFieldObjects.
	window.dataLayer = window.dataLayer || [];
	let dataLayerObj = {
		'event': 'signUp',
		'eventCategory': 'Sign Up',
		'eventAction': 'Email Updates',
		'eventCallback': function() {
			return Promise.resolve();
		},
	};
	if (window.userId) {
		dataLayerObj.userId = window.userId;
	}
	window.dataLayer.push(dataLayerObj);
}

export function pushAddToCart(productObj, plpDatalayerDataSource = null) {
	// Measure adding a product to a shopping cart by using an 'add' actionFieldObject
	// and a list of productFieldObjects.
	window.dataLayer = window.dataLayer || [];

	let datasource = [];

	// defined globally by BE;
	// eslint-disable-next-line no-undef
	if (typeof datalayerDataSource != 'undefined') {
		// defined globally by BE;
		// eslint-disable-next-line no-undef
		datasource = datalayerDataSource || [];
	}

	if (plpDatalayerDataSource) {
		datasource = plpDatalayerDataSource;
	}

	let result = datasource.find((obj) => {
		return obj.code === productObj.code;
	});

	if (result) {
		window.dataLayer.push({
			'event': 'addToCart',
			'ecommerce': {
				'currencyCode': result.currency,
				'add': { // 'add' actionFieldObject measures.
					'products': prepGtmProduct(result, productObj), //  adding a product to a shopping cart.
				},
			},
		});
	}
}

export function pushProductView(productObj, plpDatalayerDataSource = null) {
	// Measure adding a product to a shopping cart by using an 'add' actionFieldObject
	// and a list of productFieldObjects.
	window.dataLayer = window.dataLayer || [];

	let datasource = [];

	// defined globally by BE;
	// eslint-disable-next-line no-undef
	if (typeof datalayerDataSource != 'undefined') {
		// defined globally by BE;
		// eslint-disable-next-line no-undef
		datasource = datalayerDataSource || [];
	}

	if (plpDatalayerDataSource) {
		datasource = plpDatalayerDataSource;
	}

	let result = datasource.find((obj) => {
		return obj.code === productObj.code;
	});

	if (result) {
		window.dataLayer.push({
			'pageType': (plpDatalayerDataSource) ? 'plp' : 'pdp',
			'event': 'productDetail',
			'ecommerce': {
				'currencyCode': result.currency || null,
				'detail': {
					'actionField': {'list': result.category || null},
					'products': prepGtmProduct(result, productObj),
				},
			},
		});
	}
}

export function prepGtmProduct(result, productObj) {
	const data = {
		'name': result.name || null,
		'id': result.id || null,
		'price': result.price || null,
		'brand': result.brand || null,
		'category': result.category || null,
		'variant': result.colour || null,
		'dimension5': productObj.size || null,
		'dimension6': result.stock || null,
		'dimension7': result.priceType || null,
		'dimension10': result.code || null,
		'quantity': productObj.quantity || null,
	};

	data['collectionType'] = result.collectionType;

	if (result.collectionType && result.collectionType!== 'no') {
		data['collectionID'] = result.collectionID || null;
		data['collectionName'] = result.collectionName || null;
	}

	return [data];
}

export async function pushLogin(option, form = false) {
	window.dataLayer = window.dataLayer || [];
	let dataLayerObj = {
		'event': 'login',
		'eventCategory': 'login',
		'eventAction': option,
		'eventCallback': function() {
			if (form) {
				form.submit();
				return Promise.resolve();
			}

			return Promise.resolve();
		},
	};

	// content grouping
	dataLayerObj.pageType = 'login';
	window.dataLayer.push(dataLayerObj);
}

export function pushLoginError(errorMsg) {
	window.dataLayer = window.dataLayer || [];

	if (errorMsg) {
		let dataLayerObj = {
			'event': 'login error',
			'text': errorMsg,
		};

		dataLayerObj.pageType = 'login';

		window.dataLayer.push(dataLayerObj);
	}
}

export function pushUserInfo(email) {
	window.dataLayer = window.dataLayer || [];
	if (email) {
		let dataLayerObj = {
			'event': 'userIdentified',
			'identifier': email,
		};
		window.dataLayer.push(dataLayerObj);
	}
}

// Trigger immediately after any item is added to cart to indicate the total contents in the cart
export function pushCartItems(cartItems) {
	window.dataLayer = window.dataLayer || [];
	if (cartItems) {
		let dataLayerObj = {
			'event': 'cartItemsPush',
			'cartItems': cartItems,
		};
		window.dataLayer.push(dataLayerObj);
	}
}

export function pushReviewSubmited(data) {
	window.dataLayer = window.dataLayer || [];
	if (data) {
		window.dataLayer.push(data);
	}
}



// WEBPACK FOOTER //
// ./dataLayer.js